import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47cfa75b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Waiting List", -1))
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add customer to waitlist")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Add customer to waitlist")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Requested Move-in Date")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Date Added to Waiting List")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Email")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Contact")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Unit Type")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("p", null, "Available")
  ]),
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Tenant Archived", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("(Primary)")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Available")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Unavailable")
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  key: 0,
  class: "custom-box delete-box"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Are you sure you want to delete?", -1))
const _hoisted_16 = { class: "form-delete row" }
const _hoisted_17 = ["onSubmit"]
const _hoisted_18 = {
  key: 0,
  class: "form-field"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Reason", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-outline-blue"
}, " Finish ", -1))
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Rent")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Rent")
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 3,
  class: "text-center",
  style: {"margin-top":"15px"}
}
const _hoisted_28 = { key: 4 }

import { onMounted, ref } from "vue";

import api from "@virgodev/bazaar/functions/api";

import { WaitlistInterface, CustomerDataInterface } from "@/types/customers";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { UnitTypeInterface } from "@/types/unit";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const showDelete = ref(false);
const status = ref("loading");
const errors = ref("");
const selectedWait = ref();
const selectedCloseReason = ref();
const waitlist = ref(Array<WaitlistInterface>());
const unitTypes = ref();
const customers = ref();
const reasons = ref();
onMounted(async () => {
  await getWaitlist();
  status.value = "loaded";
});
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomers() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customers.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getReasons() {
  errors.value = "";
  const response = await api({
    url: `reasons/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    reasons.value = response.body.reasons;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
if (props.facilityName == "Storedge") {
  getReasons();
}
async function getWaitlist() {
  await getUnitTypes();
  await getCustomers();
  errors.value = "";
  const response = await api({
    url: `waiting_customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (props.facilityName == "ESS") {
      waitlist.value = response.body;
      for (let customer of waitlist.value) {
        customer.info = customers.value.filter(
          (item: CustomerDataInterface) => item.id == customer.customer_id
        )[0];
        customer.unit_type = unitTypes.value.filter(
          (item: UnitTypeInterface) => item.id == customer.unit_type_id
        )[0];
      }
    } else {
      waitlist.value = response.body.leads;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  const json = JSON.parse(JSON.stringify(selectedWait.value));
  json.close_reason_id = selectedCloseReason.value;
  errors.value = "";
  const response = await api({
    url: `waiting_customers/?id=${selectedWait.value.id}&facilityId=${props.facilityId}`,
    method: "PUT",
    json,
  });

  if (response.status == 200) {
    await api({
      url: `waiting_customers/?id=${selectedWait.value.id}&facilityId=${props.facilityId}`,
      method: "DELETE",
    });
    let index = waitlist.value.findIndex(function (item: WaitlistInterface) {
      return item.id === selectedWait.value.id;
    });
    if (index != -1) {
      waitlist.value.splice(index, 1);
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  selectedWait.value = "";
  showDelete.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.facilityName == 'ESS')
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                class: "btn",
                to: {
        name: 'create_waitlist',
        params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_RouterLink, {
                key: 1,
                class: "btn",
                to: {
        name: 'create_waitlist_storedge',
        params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["to"])),
          (waitlist.value.length != 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitlist.value, (customer) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: customer.id + 'customer'
                  }, [
                    (__props.facilityName == 'ESS')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("td", null, _toDisplayString(customer.move_in_on), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.created_at), 1),
                          (customer.info)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_RouterLink, {
                                    to: {
                  name: 'customer_detail_ess',
                  params: { id: customer.info.id, facilityId: __props.facilityId },
                }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(customer.info.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(customer.info.email), 1),
                                _createElementVNode("td", null, _toDisplayString(customer.info.cell_phone), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_7,
                                _hoisted_8,
                                _hoisted_9
                              ], 64)),
                          _createElementVNode("td", null, _toDisplayString(customer.unit_type.length) + " x " + _toDisplayString(customer.unit_type.width), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.unit_type.available_unit_count), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.notes), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("td", null, _toDisplayString(customer.desired_move_in_date), 1),
                          _createElementVNode("td", null, _toDisplayString(customer.created_at.split("T")[0]), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_RouterLink, {
                              to: {
                name: 'customer_detail_storedge',
                params: { id: customer.tenant.id, facilityId: __props.facilityId },
              }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(customer.tenant.first_name) + " " + _toDisplayString(customer.tenant.last_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(customer.tenant.email), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.tenant.phone_numbers, (phone) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: phone.id + 'phone'
                              }, [
                                _createTextVNode(_toDisplayString(phone.formatted_number) + " - " + _toDisplayString(phone.label) + " ", 1),
                                (phone.primary)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_10
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(customer.size), 1),
                          _createElementVNode("td", null, [
                            (customer.wait_list_available)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_11
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_12
                                ], 64))
                          ])
                        ], 64)),
                    _createElementVNode("td", _hoisted_13, [
                      (showDelete.value && customer.id == selectedWait.value.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("form", {
                                onSubmit: _withModifiers(submitForm, ["prevent"])
                              }, [
                                (reasons.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _hoisted_19,
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCloseReason).value = $event)),
                                        class: "form-select",
                                        required: ""
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reasons.value, (reason) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: reason.id + 'reason'
                                          }, [
                                            (reason.kind == 'close')
                                              ? (_openBlock(), _createElementBlock("option", {
                                                  key: 0,
                                                  value: reason.id
                                                }, _toDisplayString(reason.reason), 9, _hoisted_20))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, selectedCloseReason.value]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_21,
                                _createElementVNode("div", {
                                  class: "btn btn-outline-blue",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDelete.value = false))
                                }, " Cancel ")
                              ], 40, _hoisted_17)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (__props.facilityName == 'ESS')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_RouterLink, {
                                    class: "btn btn-blue",
                                    to: {
                  name: 'create_waitlist',
                  params: {
                    waitlistId: customer.id,
                    facilityId: __props.facilityId,
                    facilityName: __props.facilityName,
                  },
                }
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_23
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  (
                  customer.unit_type.available_unit_count > 0 && customer.info
                )
                                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                                        key: 0,
                                        class: "btn btn-blue",
                                        to: {
                  name: 'rental',
                  params: {
                    facilityId: __props.facilityId,
                    customerId: customer.info.id,
                    unitType: customer.unit_type_id,
                    unitStatus: 'available',
                  },
                }
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_24
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (customer.wait_list_available)
                                    ? (_openBlock(), _createBlock(_component_RouterLink, {
                                        key: 0,
                                        class: "btn btn-blue",
                                        to: {
                  name: 'rental_storedge',
                  params: {
                    customerId: customer.tenant.id,
                    unitType: customer.unit_group.id,
                    facilityId: __props.facilityId,
                  },
                }
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_25
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : _createCommentVNode("", true)
                                ], 64)),
                            _createElementVNode("div", {
                              class: "btn btn-outline-blue",
                              onClick: ($event: any) => {
                showDelete.value = true;
                selectedWait.value = customer;
              }
                            }, " Remove ", 8, _hoisted_26)
                          ]))
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, " No customers on waitlist ")),
          (errors.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(errors.value), 1))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})